import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/messages";

class MessagesService {
  createMessage = async ({ firstName, lastName, email, subject, message }) => {
    const body = {
      firstName,
      lastName,
      email,
      subject,
      message,
    };
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, body);
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating message.");
    }
  };

  getMessages = async ({ page = 1 } = {}) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`, {
        params: { page },
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri učitavanju poruka.");
    }
  };

  deleteMessage = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri brisanju poruke.");
    }
  };
}
const messagesService = new MessagesService();

export default messagesService;
